import {
    Validate
  } from './_formValidation';
  
  const errorTypesText = {
    invalidEmail: 'Please enter a valid email address.',
    invalidChar: 'Special characters are restricted.',
    invalidPhone: 'Please enter a valid phone number.',
    invalidAddress: 'Please enter a valid address.',
    invalidResponse: 'Please enter a valid response.',
    invalidRegistryNum: 'Please enter a valid registry number.',
    invalidReceiptNum: 'Please enter a valid receipt number.',
    invalidZip: 'Please enter a valid zip code.',
    invalidFName: 'Please enter a valid first name.',
    invalidLName: 'Please enter a valid last name.',
    invalidPopNum: 'Please enter a valid POP number.',
    invalidGiftCertPIN: 'Please enter a valid Gift Certificate PIN Number.',
    invalidGiftCert: 'Please enter a valid Gift Certificate Number.',
    invalidPassCode: 'Please enter a valid passcode.',
    invalidAuthenticationCode: 'Please enter a valid Authentication Code',
    tooLong: 'Character limit reached.',
    tooShort: 'Please enter the minimum character amount.',
    tooShortPassCode: 'Passcode requires a 6-digit number.',
    tooShortAuthenticationCode: 'Authentication code requires a 6-digit number.',
    tooShortFName: 'First name requires at least 2 characters.',
    tooShortLName: 'Last name requires at least 2 characters.',
    tooShortAddress: 'Address requires at least 2 characters.',
    tooShortCity: 'City requires at least 3 characters.',
    tooShortZip: 'Zip code requires at least 5 or 9 numbers.',
    tooShortPhone: 'Phone requires at least 10 numbers.',
    tooShortEmail: 'Email requires at least 5 characters.',
    tooShortGiftCertPIN: 'A 3-digit PIN is required.',
    doNotMatchEmail: 'Enter a valid email address that matches the email address entered.',
    doNotMatchPW: 'Enter a valid password that matches the password entered.',
    tooShortCardNumber: 'Gift Card number invalid.',
    tooShortCardNumberPIN: 'A 3-digit PIN Number is required.',
    tooShortOrderNum: 'Order Number requires a 9-digit or 10-digit number.',
    tooShortGiftCert: 'Gift Card number invalid.',
    tooShortPOPNum: 'POP Number requires a 12-digit number.',
    tooShortReceiptNumber: 'Receipt number must be 19 characters.',
    tooShortPOPNumber: 'POP number must be 12 characters.',
    required: 'This field is required.',
    requiredSelect: 'Please select a response.',
    requiredState: 'State is required.',
    requiredStateCode: 'State is required.',
    requiredMonth: 'Month is required.',
    requiredDay: 'Day is required.',
    requiredYear: 'Year is required.',
    requiredStore: 'Store location is required.',
    requiredPassword: 'Password is required.',
    requiredFName: 'First name is required.',
    requiredLName: 'Last name is required.',
    requiredFeedback: 'Please enter your feedback.',
    requiredRating: 'A rating is required.',
    requiredZip: 'Zip code is required.',
    requiredRegistryNum: 'Registry number is required.',
    requiredReceiptNum: 'Receipt number is required.',
    requiredPhone: 'Phone number is required.',
    requiredAddress: 'Address is required.',
    requiredEmail: 'Email address is required.',
    requiredCity: 'City is required.',
    requiredPopNum: 'POP number is required.',
    requiredPIN: 'Password Reset Code is required.',
    requiredAuthenticationCode: 'Authentication Code is required.',
    requiredCardNum: 'Gift Card Number is required',
    requiredCardNumPIN: 'PIN Number is required',
    requiredOrderNum: 'Order Number is required.',
    requiredReturnReason: 'Return comment is required.',
    requiredRegEventType: 'Select a registry type.'
  }
  
  // ********** RULES TO VALIDATE AGAINST *************
  const validationRules = {
    email: {
        min: 1,
        max: 50,
        pattern: "[^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$]",
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortEmail,
            invalid: errorTypesText.invalidEmail,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredEmail
        },
    }, 
    password: {
        min: 1,
        max: 50,
        pattern: "[<>{#\`~$\&^+=<>\"|%}';\u20ac\u00a3\u00a5]",
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShort,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredPassword
        }
    },
    firstName: {
        min: 2,
        max: 15,
        // letters and ' and -
        pattern: "[a-z A-Z\-']",
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortFName,
            invalid: errorTypesText.requiredFName,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredFName
        },
    },
    lastName: {
        min: 2,
        max: 25,
        // letters and ' and -
        pattern: "[a-z A-Z\-']",
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortLName,
            invalid: errorTypesText.requiredLName,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredLName
        },
    },
    address: {
        min: 2,
        max: 60,
        // letters, numbers, #, /, -
        pattern: '[\- a-z A-Z 0-9\#\/]',
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortAddress,
            invalid: errorTypesText.invalidAddress,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredAddress
        },
    },
    city: {
        min: 3,
        max: 20,
        // letters and ' and -
        pattern: "[a-z A-Z\-']",
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortCity,
            invalid: errorTypesText.invalidEmail,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredCity
        },
    },
    state: { 
        min: 2,
        max: 2,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredState
        },
    },
    stateCode: {
        min: 2,
        max: 2,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredState
        },
    },
    zip: {
        min: 5,
        max: 10,
        // numbers only
        pattern: "^[0-9]{5}(?:-[0-9]{4})?$",
        pattern2: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortZip,
            invalid: errorTypesText.invalidZip,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredZip
        },
    },
    phone: {
        min: 10,
        max: 14,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortPhone,
            invalid: errorTypesText.invalidPhone,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredPhone
        },
    },
    dateday: { 
        min: 2,
        max: 2,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredDay
        },
    },
    datemonth: { 
        min: 2,
        max: 2,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredMonth
        },
    },
    dateyear: { 
        min: 4,
        max: 4,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredYear
        },
    },
    long: {
        min: 1,
        max: 1000,
        // any are allowed
        pattern: '',
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShort,
            required: errorTypesText.required
        },
    },
    registryNumber: { 
        min: 9,
        max: 9,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShort,
            invalid: errorTypesText.invalidRegistryNum,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredRegistryNum
        },
    },
    eventType: {
        errorMsg: {
            required: errorTypesText.requiredRegEventType
        },
    },
    cardNumber: { 
        min: 10,
        max: 16,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooShort: errorTypesText.tooShortCardNumber,
            required: errorTypesText.requiredCardNum
        },
    },
    gcPin: { 
        min: 3,
        max: 3,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooShort: errorTypesText.tooShortCardNumberPIN,
            required: errorTypesText.requiredCardNumPIN
        },
    },
    orderNumber: { 
        min: 9,
        max: 10,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooShort: errorTypesText.tooShortOrderNum,
            required: errorTypesText.requiredOrderNum
        },
    },
    receiptNum: { 
        min: 19,
        max: 19,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortReceiptNumber,
            invalid: errorTypesText.invalidReceiptNum,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredReceiptNum
        },
    },
    popNumber: { 
        min: 12,
        max: 12,
        // numbers only
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortPOPNum,
            invalid: errorTypesText.invalidPOPNum,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredPopNum
        },
    },
    validationPin: {
        min: 6,
        max: 6,
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortPassCode,
            invalid: errorTypesText.invalidPassCode,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredPIN
        },
    },
    authenticationCode: {
        min: 6,
        max: 6,
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortAuthenticationCode,
            invalid: errorTypesText.invalidAuthenticationCode,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredAuthenticationCode
        },
    },
    giftCertificate: {
        min: 10,
        max: 16,
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortGiftCert,
            invalid: errorTypesText.invalidGiftCert,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredGiftCert
        },
    },
    giftCertificatePIN: {
        min: 3,
        max: 3,
        pattern: /^[0-9]*$/,
        errorMsg: {
            tooLong: errorTypesText.tooLong,
            tooShort: errorTypesText.tooShortGiftCertPIN,
            invalid: errorTypesText.invalidGiftCertPIN,
            invalidChar: errorTypesText.invalidChar,
            required: errorTypesText.requiredCardNumPIN
        },
    },

    retComment: {
        min: 1,
        max: 250,
        pattern: '',
        errorMsg: {
            required: errorTypesText.requiredReturnReason
        },
    },
    aliases: {
        zipCode: 'zip',
        logonId: 'email',
        contactEmail: 'email',
        logonIdVerify: 'email',
        logonPassword: 'password',
        logonPasswordVerify: 'password',
        notASearch: 'address',
        contactState: 'state',
        address1: 'address', 
        address2: 'address',
        addressone: 'address',
        contactPhone: 'phone',
        phone1: 'phone',
        billing_phone1: 'phone',
        billing_phone: 'phone',
        billing_firstName: 'firstName',
        billing_lastName: 'lastName',
        billing_city: 'city',
        billing_state: 'state',
        billing_zipCode: 'zip', 
        shipping_firstName: 'firstName',
        shipping_lastName: 'lastName',
        shipping_city: 'city',
        shipping_state: 'state',
        shipping_zipCode: 'zip',
        newAddrFirstName: 'firstName',
        newAddrLastName: 'lastName',
        newAddrAddress: 'address',
        newAddrCity: 'city',
        newAddrState: 'state',
        newAddrZip: 'zip',
        newAddrPhone: 'phone',
        pin: 'giftCertificatePIN',
        order: 'orderNumber',
        sender_name: 'firstName',
        feedback_textarea: 'long',
        feedbackEmailInput: 'email',
        popNumbers: 'popNumber',
        name: 'firstName',
        oneTimePasscode: 'authenticationCode',
    } 
  }

  // -------------------------------------------------------
  // -------- SEE VALIDATEINPUT FOR HOW TO USE -------------
  // -------------------------------------------------------
  
  // strips characters based off of datapattern and input type
  function removeChars (input, pattern) {
    let result = "";
    var focusPattern = pattern;
  
    for (let x = 0; x < input.length; x++) {
        var currentChar = input.charAt(x);
        var currentCharAscii = input.charCodeAt(x);
        var lastChar = input.charAt(x-1);
        var lastCharAscii = input.charCodeAt(x-1);
        var twoCharsBackAscii = input.charCodeAt(x-2);
                
        //iOS smart punctuation characters for apostrophe and single quote
        if (currentCharAscii == '8216' || currentCharAscii == '8217') {
            currentChar = "'";
        }
        //ADDRESS only allow 1 # at a time
        if (currentChar == "#") {
            if (lastChar=="#") {
                currentChar = "";
            }
        }
        //ADDRESS only allow 1 - at a time
        if (currentChar == "-") {
            if (lastChar=="-") {
                currentChar = "";
            }
        }
        if (currentChar.search(focusPattern) > -1) result += currentChar;
  
        if (result.trim() == '') result = '';
        
        //ADDRESS remove spaces around / slashes
        if (input.length >= 3) {
            if (currentCharAscii == 47 && lastCharAscii == 32) {
                result = input.split(" /").join("/");
            }
            if (twoCharsBackAscii == 47 && lastCharAscii == 32) {
                result = input.split("/ ").join("/");
            }
        }
    }
    
    return result;
  }
 
  // ***************** End Char Functions ********************
  
  // -------------------------------------------------------------------
  // --------------------- PASS IN INPUT ELEMENT -----------------------
  // -------------------------------------------------------------------
  // ------ NAME ATTRIBUTE SHOULD MATCH VALIDATIONRULES OBJ KEY --------
  // -------------------------------------------------------------------
  
  // ---------------- validate on blur -----------------
function validateInputOnBlur (input) {

    var id, inputForError, input_name, isChecked, onBlurValidateAttr, required, matches, ruleMin, ruleMax, ruleErrMsg, rulePattern, topValue;
    var value = input.value;
    var length = input.value.length;
      

    //All input fields with .inline-focus have an attribute data-validate. This is used for required on inline focus.
    //These data-validate fields are ALSO used when form is submitted. On submit, _formValidation still will handle any errors
    if (input.getAttribute('data-validate')) {
        input.getAttribute('data-validate').length > 0 ? (onBlurValidateAttr = input.getAttribute('data-validate').split(',')) : (onBlurValidateAttr = input.getAttribute('data-validate'));
    
    }
    if(onBlurValidateAttr) {
        onBlurValidateAttr = onBlurValidateAttr.toString();
        //is this field required? set required variable for further down in the rule logic
        if (onBlurValidateAttr.includes('required') ? required='true' : required='false');
        //is this field a "matches" field? for email addresses and passwords - matches variable is used further down in the rule logic
        if (onBlurValidateAttr.includes('matches')) {
            //need input name of field we are comparing
            if(onBlurValidateAttr.includes('create-password')) {
                matches = '#create-password';
            }
            if(onBlurValidateAttr.includes('logonId')) {
                matches = '#logonId';
            }
        }
    }
    //Registry input names for Month/Day/Year have dashes
    input_name = input.name.replace('-', '');
    
    //Registry input names also have a dynamic number on the end of their names based on your registry number - so removing all numbers
    input_name = input_name.replace(/[0-9]/g, '');

    const name = validationRules[input_name] ? input_name : validationRules.aliases[input_name];

    if(name=="phone") {

        value = value.replace(/\D/g,'');
        length = value.length;
    }

    // Finds the rule associated with name. 
    const rule = validationRules[name];

    if(rule) {
        ruleMin = rule.min;
        ruleMax = rule.max;
        ruleErrMsg = rule.errorMsg;
        rulePattern = rule.pattern;
 

        let isValid = true;
        let text = undefined;
        
        if (length > ruleMax) {
            isValid = false;
            text = ruleErrMsg.tooLong;
            showErrMessage(input.id, text);
        }
        if (length < ruleMin && length > 0) {
            isValid = false;
            text = ruleErrMsg.tooShort;
            showErrMessage(input.id, text);
        }
        if (length === 0 && required == 'true') {
            isValid = false;
            text = ruleErrMsg.required;
            showErrMessage(input.id, text);
            
        }
        // state gets ~special~ treatment
        if (name === 'state') {
            if (value === '*') {
                isValid = false;
                text = ruleErrMsg.required;
            } else {
                isValid = true;
            }
        }
        // zip gets ~special~ treatment
        if (name === 'zip') {
            if (value.includes('_')) {
                isValid = false;
                text = ruleErrMsg.invalid
                showErrMessage(input.id, text);
            }
        }
        //email gets ~special~ treatment
        if (name === 'email' && value.length > 0) {
            if (!Validate.isValidEmail(value)) {
                isValid = false;
                text = ruleErrMsg.invalid;
                showErrMessage(input.id, text);
            }   
        }
        //Registry required dates

        if (name === 'datemonth') {
            if (value === '*') {
                isValid = false;
                text = ruleErrMsg.required;
            } else {
                isValid = true;
            }
        }
        if (name === 'dateyear') {
            if (value === '*') {
                isValid = false;
                text = ruleErrMsg.required;
            } else {
                isValid = true;
            }
        }
        if (name === 'dateday') {
            if (value === '*') {
                isValid = false;
                text = ruleErrMsg.required;
            } else {
                isValid = true;
            }
        }
    }
}
  // -------------------Validation Error Message------------
  function showErrMessage (errID, errText) {

    var inputFieldForErr;
    inputFieldForErr = $('#' + errID).attr('name') + '-error-message';

   
    //if any error styling - delete
    if (errID){
    $('#' + errID).parent().removeClass('has-error');
    $('#' + errID).parent().parent().removeClass('has-error');
    $('#' + errID).removeAttr('aria-describedby').siblings('.tooltip, p.txt-error, span.sr-only').remove();

    //Add Error and Error Styling
    $('#' + errID).parent().addClass('has-error');
    $('#' + errID).attr('aria-describedby', inputFieldForErr);
    $("<p class='help-block txt-error' id='" + inputFieldForErr + "'>" + errText + "</p>").insertAfter('#' + errID);
    $("<span class='sr-only'>" + errText + "</span>").insertAfter('#' + errID);
    }
  }

  // ------------ validate on input --------------
  function validateInputOnInput(input) {

    //Clear out any existing error styles
    if ($('#' + input.id).parent().hasClass('has-error') || $('#' + input.id).hasClass('has-error')) {
        $('#' + input.id).parent().removeClass('has-error');
        $('#' + input.id).removeAttr('aria-describedby').siblings('.tooltip, p.txt-error, span.sr-only').remove();
    }
    if (input.id == 'feedback_textarea') {
        $('#feedback_textarea').parent().removeClass('has-error');
        $('#feedback_textarea').removeAttr('aria-describedby').siblings('.tooltip, p.txt-error, span.sr-only').remove();

    }
    var id, idWithHash, inputName, inputType, inputVal, inputChecked;
    id = input.id;
    idWithHash = '#' + id;
    inputName = input.name;
    inputType = input.type;
    inputVal = input.value;
    inputChecked = input.checked;
    
    
    //Each input that needs to be validated has an attribute called patterntype.
    //The patterntype is a reg exp that has what chars are or are not allowed
    var dataPattern = input.getAttribute('patterntype');
    
    //All name fields
    if (dataPattern == "name") {
        var inputPattern = "[a-z A-Z\-']";
        input.value = removeChars(inputVal, inputPattern);
    }
    //All address fields
    if (dataPattern == "address") {
        inputPattern = "[\- a-z A-Z 0-9\#\/]";
        input.value = removeChars(inputVal, inputPattern);
    }
    //City
    if (dataPattern == "city") {
        inputPattern = "[a-z A-Z\-']";
        input.value  = removeChars(inputVal, inputPattern);        
    }
    //Textarea inputs on Share my WishList, Share Product
    if (dataPattern == "shareMessage") {
        inputPattern = "[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\?\\.\\,\\[\\]\\#\\\"' ]";
        input.value = removeChars(inputVal, inputPattern);
    }
    //Textarea inputs on gift messages for products in shopping cart
    if (dataPattern == "giftMessage") {
        inputPattern = "[a-zA-Z0-9\\!\\@\\*\\(\\)\\:\\?\\.\\,\\#\\' \\\-\\$\\%\\&\\+\/]";
        input.value = removeChars(inputVal, inputPattern);
    }
    //Static Search Field
    if (dataPattern == "searchField") {
        inputPattern = "[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\?\\.\\,\\\\\\/\\#\\\"\\Ø\\ø\\&\\+' ]";
        input.value = removeChars(inputVal, inputPattern);
    }
    //Registry Number
    if (dataPattern == "regNum") { 
        inputPattern = "[0-9]";
        input.value = removeChars(inputVal, inputPattern);
    }
    //POP Number
    if (dataPattern == "popNum") { 
        inputPattern = "[0-9]";
        input.value = removeChars(inputVal, inputPattern);
    }

  }
//An input has been given focus, so what input is it? Add an onblur event to it
function validateOnFocus(input) { 
    $(input).one('blur', function() {
      const shouldValidate = this.value !== ''
      if (shouldValidate) {
        validateInputOnBlur(input);
      }
    });
}
  //This binds to all inputs with a class of .inline-focus - listening for focus and input changes
  //On focus, validateOnFocus which will take that focused input and add an onBlur event to it
  //On input change, it determines what type of input field and will strip invalid characters as user types
  //input change will also catch smartyaddress changes in the city/state/zip input field to recheck their validation
  export const inlineFormValidationOnBlur = () => {

    $('.inline-focus').on('click keydown focus', function(event) {
        validateOnFocus(this);
    });
    $('.inline-focus').on('input change', function() {
        validateInputOnInput(this);
    });
  }
  